var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('WsCRUD',{attrs:{"modelName":_vm.modelName,"label":_vm.label,"fields":_vm.fields,"liveSearching":true,"sortBy":_vm.sortBy,"showFields":_vm.showFields,"updateHideFields":_vm.updateHideFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }